import React from 'react'

import { ThemeProvider } from '@emotion/react'

import breakpoints from '../theme/breakpoints'
import { Colors, getColorsByThemeVariant, ThemeVariant } from '../theme/colors'
import getDropShadows from '../theme/dropShadows'
import maxWidths from '../theme/maxWidths'
import motion from '../theme/motion'
import selectors from '../theme/selectors'
import spacing from '../theme/spacing'
import typography, { pxToRem } from '../theme/typography'
import weights from '../theme/weights'
import GlobalStyles from './GlobalStyles'

interface Props {
  themeVariant?: ThemeVariant
  darkMode?: boolean
  children: React.ReactNode
  bodyBackground?: Colors
}

const CashDesignSystemProvider: React.FC<Props> = ({
  children,
  darkMode = false,
  bodyBackground = 'background',
  themeVariant = 'default',
}) => {
  const colors = getColorsByThemeVariant({ themeVariant, darkMode })
  const dropShadows = getDropShadows(darkMode)

  return (
    <ThemeProvider
      theme={{
        darkMode,
        colors,
        maxWidths,
        motion,
        typography,
        weights,
        dropShadows,
        breakpoints,
        pxToRem,
        selectors,
        spacing,
      }}
    >
      <GlobalStyles bodyBackground={bodyBackground} />
      {children}
    </ThemeProvider>
  )
}

export default CashDesignSystemProvider
